class FieldmapInfoCtrl {
  constructor(SchemaService, AuthService, TemplateService) {
    'ngInject';
    this.ss = SchemaService;
    this.as = AuthService;
    this.ts = TemplateService;
   
    this.tables = [];
    this.keyFields = [];
    this.fieldMap = {};
    this.refIds = [];
  }
  
  async $onInit() {
    try {
      const [allDbs, PROVIDER, templateData] = await Promise.all([
        this.ss.getGrantedDBs(), 
        this.as.getProviderSettings(),
        this.ts.getTemplateData()
      ]);
      this.PROVIDER = PROVIDER;
      this.td = templateData;
      this.refIds = this.td.template.references.map(ref => ref.id);
      this.templateId = this.ts.templateId;
      this.tables = allDbs.filter(db => (!PROVIDER.handleAppsIndependently || db.appId === this.td.template.appId) && !!db.tableName);
    } catch (error) {
      const rawMessage = {error, when: "During Field Mapper Setup"};
      this.handleMessage({rawMessage});
    }

  }
  
  resetSourceTable() {
    this.sourceSchema = {};
    this.sourceKeyFields = [];
  }
  
  async tableSelected(tableId) {
    try {
      this.fieldMap = {};
      this.sourceSchema = await this.ss.getSchema(this.td.template, tableId);
      this.sourceKeyFields = this.sourceSchema?.fields.filter(f => f.isForeignKey || f.isPrimaryKey);
      if (this.tableOnly) return;
      
      this.setPrimaryKey(tableId);
    } catch (error) {
      const rawMessage = {error, when: "Loading Table Information"};
      this.handleMessage({rawMessage});
    }
  }
  
  setPrimaryKey(tableId){ //if there is 1 reference of chosen table, populate pKey
    const primaryRefs = this.ts.references.filter(ref => ref.tableId === tableId);
    if (primaryRefs.length !== 1) return;
    const recordIdField = this.sourceSchema?.fields.find(f => !!f.isPrimaryKey);
    if (recordIdField) this.fieldMap[primaryRefs[0].id] = {recordIdField};
  }

  refLinkFieldMissing(ref) {
    if (!this.conditionalRequire) return true;
    // Require when no recordIdField is set for any reference, or reference not allowed to submit on update and field is not set
    return !this.refIds.some(refId => !!this.fieldMap[refId]?.recordIdField) || 
      (!ref.allowSubmitOnUpdate && !this.fieldMap[ref.id]?.recordIdField);
  }
}

export default {
  bindings: {
    handleMessage: "&",
    tableId: "=",
    label: "=",
    fieldMap: "=",
    tableOnly: "<",
    labelType: "<",
    sourceSchema: "=",
    conditionalRequire: "<"
  },
  templateUrl: "form-builder/build-wizard/fieldmap-info/fieldmap-info.component.html",
  controller: FieldmapInfoCtrl
};